export default "__VITE_ASSET__DP6g9sZz__"